import vars from '../../common/vars';

export default function loadGotie() {
  const gotieJs = 'https://gotie.tunein.com/static/gotie.min.js';
  window.GOTIE_API = vars.get('GOTIE_API');

  /* eslint-disable */
  !function(e,t,i,n,o,s,u,c,r,a){
    if(!e[n]||!e[n].queued){
      for(;c<u.length;)o(s,u[c++]);
      (r=t.createElement(i)).async=1,
        r.src=gotieJs,
        (a=t.getElementsByTagName(i)[0]).parentNode.insertBefore(r,a),e[n]=s}
  } (
    window,
    document,
    'script',
    'gotie',
    function(e,t){e[t]=function(){e.queued.push([t,arguments])}},
    {queued:[],_v:1},
    'init track'.split(' '),
    0
  );
  /* eslint-enable */
}
